import {
  getLoyaltyProgram as publicGetLoyaltyProgram,
  bulkGetLoyaltyProgram as publicBulkGetLoyaltyProgram,
  updateLoyaltyProgram as publicUpdateLoyaltyProgram,
  activateLoyaltyProgram as publicActivateLoyaltyProgram,
  pauseLoyaltyProgram as publicPauseLoyaltyProgram,
  getLoyaltyProgramPremiumFeatures as publicGetLoyaltyProgramPremiumFeatures,
  enablePointsExpiration as publicEnablePointsExpiration,
  disablePointsExpiration as publicDisablePointsExpiration,
} from './loyalty-v1-program-programs.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onProgramUpdated as publicOnProgramUpdated } from './loyalty-v1-program-programs.public.js';

export const getLoyaltyProgram: MaybeContext<
  BuildRESTFunction<typeof publicGetLoyaltyProgram> &
    typeof publicGetLoyaltyProgram
> = /*#__PURE__*/ createRESTModule(publicGetLoyaltyProgram);
export const bulkGetLoyaltyProgram: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetLoyaltyProgram> &
    typeof publicBulkGetLoyaltyProgram
> = /*#__PURE__*/ createRESTModule(publicBulkGetLoyaltyProgram);
export const updateLoyaltyProgram: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLoyaltyProgram> &
    typeof publicUpdateLoyaltyProgram
> = /*#__PURE__*/ createRESTModule(publicUpdateLoyaltyProgram);
export const activateLoyaltyProgram: MaybeContext<
  BuildRESTFunction<typeof publicActivateLoyaltyProgram> &
    typeof publicActivateLoyaltyProgram
> = /*#__PURE__*/ createRESTModule(publicActivateLoyaltyProgram);
export const pauseLoyaltyProgram: MaybeContext<
  BuildRESTFunction<typeof publicPauseLoyaltyProgram> &
    typeof publicPauseLoyaltyProgram
> = /*#__PURE__*/ createRESTModule(publicPauseLoyaltyProgram);
export const getLoyaltyProgramPremiumFeatures: MaybeContext<
  BuildRESTFunction<typeof publicGetLoyaltyProgramPremiumFeatures> &
    typeof publicGetLoyaltyProgramPremiumFeatures
> = /*#__PURE__*/ createRESTModule(publicGetLoyaltyProgramPremiumFeatures);
export const enablePointsExpiration: MaybeContext<
  BuildRESTFunction<typeof publicEnablePointsExpiration> &
    typeof publicEnablePointsExpiration
> = /*#__PURE__*/ createRESTModule(publicEnablePointsExpiration);
export const disablePointsExpiration: MaybeContext<
  BuildRESTFunction<typeof publicDisablePointsExpiration> &
    typeof publicDisablePointsExpiration
> = /*#__PURE__*/ createRESTModule(publicDisablePointsExpiration);
/**
 * Triggered when a loyalty program is updated.
 */
export const onProgramUpdated: BuildEventDefinition<
  typeof publicOnProgramUpdated
> &
  typeof publicOnProgramUpdated = createEventModule(publicOnProgramUpdated);

export {
  ProgramStatus,
  Status,
  Type,
  FeaturePeriod,
  ContractSwitchClassification,
  V1Type,
  WebhookIdentityType,
} from './loyalty-v1-program-programs.universal.js';
export {
  LoyaltyProgram,
  PointDefinition,
  FocalPoint,
  PointsExpiration,
  PremiumFeatures,
  SocialMediaSettings,
  SocialMediaChannel,
  GetLoyaltyProgramRequest,
  GetLoyaltyProgramResponse,
  BulkGetLoyaltyProgramRequest,
  BulkGetLoyaltyProgramResponse,
  ProgramInSite,
  UpdateLoyaltyProgramRequest,
  UpdateLoyaltyProgramResponse,
  PointsExpirationConfigurationChanged,
  PointsExpirationChanges,
  ActivateLoyaltyProgramRequest,
  ActivateLoyaltyProgramResponse,
  LoyaltyProgramActivated,
  PauseLoyaltyProgramRequest,
  PauseLoyaltyProgramResponse,
  GetLoyaltyProgramDescriptionRequest,
  GetLoyaltyProgramDescriptionResponse,
  UpdateLoyaltyProgramDescriptionRequest,
  UpdateLoyaltyProgramDescriptionResponse,
  LoyaltyProgramDescriptionUpdated,
  GetLoyaltyProgramPremiumFeaturesRequest,
  GetLoyaltyProgramPremiumFeaturesResponse,
  EnablePointsExpirationRequest,
  EnablePointsExpirationResponse,
  PointsExpirationEnabled,
  DisablePointsExpirationRequest,
  DisablePointsExpirationResponse,
  PointsExpirationDisabled,
  FeatureEvent,
  FeatureEventEventOneOf,
  FeatureEnabled,
  FeatureEnabledReasonOneOf,
  Feature,
  FeatureQuantityInfoOneOf,
  FeatureContext,
  BooleanFeature,
  QuotaFeature,
  QuotaInfo,
  QuotaInfoEntry,
  TransferredFromAnotherAccountReason,
  ReassignedFromSiteReason,
  AssignedFromFloatingReason,
  NewFeatureReason,
  ContractSwitchedReason,
  ManualFeatureCreationReason,
  MigratedFromLegacyReason,
  ManualSyncReason,
  FeatureDisabled,
  FeatureDisabledReasonOneOf,
  UnAssingedToFloatingReason,
  ReplacedByAnotherSubscriptionReason,
  ReassignedToAnotherSiteReason,
  FeatureUpdated,
  FeatureUpdatedPreviousQuantityInfoOneOf,
  FeatureUpdatedReasonOneOf,
  FeatureCancelled,
  FeatureCancelledReasonOneOf,
  TransferredToAnotherAccountReason,
  CancelRequestedReason,
  QuotaExhaustedReason,
  FeatureQuotaUsageChanged,
  Empty,
  LoyaltyAppInstallation,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ProgramUpdatedEnvelope,
} from './loyalty-v1-program-programs.universal.js';
export {
  ProgramStatusWithLiterals,
  StatusWithLiterals,
  TypeWithLiterals,
  FeaturePeriodWithLiterals,
  ContractSwitchClassificationWithLiterals,
  V1TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './loyalty-v1-program-programs.universal.js';
